import React from "react";
import BenefitDescription from "./BenefitDescription";
import BenefitImage from "./BenefitImage";

import benefit1 from "../images/benefit-1.svg"
import benefit2 from "../images/benefit-2.svg"
import benefit3 from "../images/benefit-3.svg"

function BenefitSection(props) {

  return (
    <div className="container px-2 md:px-4 lg:px-8 mx-auto my-8 lg:my-16">
      {/* <h3 className="text-3xl leading-8 font-extrabold text-center tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
        Benefits
      </h3> */}
      <div className="flex flex-col md:flex-row py-12 lg:py-16 relative">
        <div className="absolute benefit-description-background h-full w-1/2 right-0 transform translate-x-1/2 -translate-y-10"></div>
        <BenefitDescription
          heading="Landing pages are a pain"
          fade="right"
          description="We've all been there. You're working hard on your product and then you realize you have to devote a huge chunk of time to the landing page.
            Maybe you'll use a landing page builder? That'll be easy and quick right? Except it never is and you have better things to do with your time. We build you a 
            done for you landing page so you don't have to worry."
          bulletpoints={[
            'Hassle free',
            'Mobile responsive',
            'Lightning fast (90+ Lighthouse scores)'
          ]}
        />
        <BenefitImage fade="left" imageSrc={benefit1} imageWidth="w-5/6 md:w-9/12" />
      </div>
      <div className="flex flex-col-reverse md:flex-row py-12 relative">
        <div className="absolute benefit-description-background h-full w-1/2 left-0 transform -translate-x-1/2 -translate-y-10"></div>
        <BenefitImage fade="right" imageSrc={benefit2} imageWidth="w-5/6 md:w-9/12" />
        <BenefitDescription
          fade="left"
          heading="Conversion  optimized"
          description="We build out your landing page using tried and tested marketing principles. Your page will be setup to maximise your call to action."
          bulletpoints={[
            'Consistent branding and content strategies',
            'Smooth and crisp UX',
            'SEO friendly'
          ]}          
        />
      </div>
      <div className="flex flex-col md:flex-row py-12 lg:py-16">
        <BenefitDescription
          fade="right"
          heading="Setup to scale"
          description="We use Gatsby (a React framework) and Netlify to deploy the site on super fast CDNs i.e. your website is going to be fast and be able to
            handle high traffic. Functionalities like Google Analytics, forms, authentication and Stripe are easy to add."
          bulletpoints={[
            'Progressive Web App (PWA)',
            'Form Integration',
            'Advanced functionalities available'
          ]}          
        />
        <BenefitImage fade="left" imageSrc={benefit3} imageWidth="w-5/6 md:w-9/12" />
      </div>
    </div>
  )
}

export default BenefitSection;